import React, { useState } from 'react'
import { Link } from 'react-router-dom'
export default function Footer() {
    const [year] = useState(new Date().getFullYear());
    const STATIC_CONTACTS = {
        email: "Info@cerastarplumber.com",
        hours: "Mon-Fri 09.30 AM - 5.30PM",
        phone: "18002026182",
    }
    const userName = localStorage.getItem("user_name")

    return (
        <>
            <footer className="">
                <div className="dashboard-header-mock-strip" style={{ width: "100%" }}>
                    <span>{STATIC_CONTACTS.email}</span>
                    <span>{STATIC_CONTACTS.hours}</span>
                    <span>{STATIC_CONTACTS.phone}</span>
                    <span>{userName}</span>
                </div>
            </footer>
        </>
    )
}
